import React, { useState, useRef, useEffect } from 'react';
import { signInWithGoogle, checkUserAuth } from '../firebase';
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import Header from '../master_root/header';
import Footer from '../master_root/footer';
import './login.css';
import { useNavigate, useLocation } from "react-router-dom";

export default function Login() {
    const navigate = useNavigate();
    const location = useLocation();
    const [userlogin, setUserLogin] = useState(false);
    const popupRef = useRef(null);
    const [user, setUser] = useState(null);

  const handleGoBack = () => {
  if (window.history.length > 1) {
    navigate(-1); // Go back
  } else {
    navigate('/'); // No history, go to home
  }
};
useEffect(() => {
    const existingUser = Cookies.get("guid");

    if (existingUser !== null && existingUser !== undefined) {
        // If cookie exists, redirect to home page
       handleGoBack();
    }
}, []);

    const handleGoogleLogin = async () => {
        try {
            await signInWithGoogle();
            
        } catch (err) {
            console.error("Google sign-in error:", err);
        }
    };

    const handleLogin = (e) => {
        e.preventDefault();
        // Handle email/password login here
        console.log("Login form submitted.");
    };

    return (
        <div>
            <Helmet>
                <title>KangDesk - Secure Login</title>
                <meta name="description" content="Login to your KangDesk account and access smart tools for HR, payroll, and accounting — all in one secure platform." />
                <meta name="keywords" content="KangDesk login, HR software login, payroll access, accounting login, secure business platform, employee login, admin dashboard" />
                <meta name="author" content="KangDesk.com" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="KangDesk – Secure Login Portal" />
                <meta property="og:description" content="Access your KangDesk dashboard to manage HR, payroll, and accounting operations with ease." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.kangdesk.com/login" />
                <meta property="og:image" content="https://www.kangdesk.com/images/kangdesk_logo.png" />
            </Helmet>

            <Header />
            <div className='app_header_height'></div>
            <div className="container_roots">
                <div className="container_size">
                    <form className="form" onSubmit={handleLogin}>
                        <div className="flex-column">
                            <label>Login ID</label>
                        </div>
                        <div className="inputForm">
                            <input type="email" className="input" placeholder="Enter your login id" required />
                        </div>

                        <div className="flex-column">
                            <label>Password</label>
                        </div>
                        <div className="inputForm">
                            <input type="password" className="input" placeholder="Enter your Password" required />
                        </div>

                        <div className="flex-row">
                            <div>
                                <input type="checkbox" id="rememberMe" />
                                <label htmlFor="rememberMe"> Remember me</label>
                            </div>
                            {/* <span className="span">Forgot password?</span> */}
                        </div>

                        <button type="submit" className="button-submit">Sign In</button>

                        <p className="p">Don't have an account? <span className="span">Sign Up</span></p>
                        <p className="p line">Or Admin With</p>

                        <div className="flex-row">
                            <button type="button" className="btn google" onClick={handleGoogleLogin}>
                                <svg version="1.1" width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    
                                </svg>
                                Sign in with Google
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <Footer/>
        </div>
    );
}
